import { useQuery } from '@tanstack/react-query';
import { fetchUnitsOfMeasurement } from '../services/productService';
import { ISelectOption } from '@common/types';

export const queryKey = 'fetchUnitsOfMeasurement';

export const useFetchUnitsOfMeasurement = (search: string | null = null, limit?: number) => {
  const { data, isFetching, isFetched } = useQuery([queryKey], () => fetchUnitsOfMeasurement(search, limit), {
    select: (data) =>
      data?.map((x: { name: string; snomedCode: string }) => ({
        label: x.name,
        value: x.snomedCode,
      })) as ISelectOption[],
    staleTime: Infinity,
  });

  return {
    unitsOfMeasurement: data,
    isFetching,
    isFetched,
  };
};
